import React from "react";
import "./stylesheets/App.scss";
import firebase from "./FirebaseConfig.js";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import Loading from "./helperComponents/Loading";
import { LOGGED, UNKNOWN, UNLOGGED } from "./util/constants";
import { routes } from "./util/router.js";
import IndexLayout from "./Layouts";
import { apiRequest, signout } from "./util/services";
import $ from "jquery";
import { setWithExpiry, getParams, normalizeTheme } from "util/common";
import { BRAND, BRAND_THEME, DARK } from "theme/tokens";
import { SET_USER } from "redux/user/actions.js";
import { connect } from "react-redux";
import KpiPresentationView from "pages/GlobalExecutiveDashboard/KpiView/KpiPresentationView";
import history from "./history";
import i18n from "./i18next.js";
import {
  persistAppLanguage,
  resolveAuthenticatedAppLanguage,
} from "util/locale";
import Login from "authentication/Login";
import {
  initProductAnalytics,
  resetProductAnalytics,
} from "util/productAnalytics";
import ResetPassword from "authentication/Verification/ResetPassword";
import ConnectConsent from "pages/ConnectConsent";
import PageNotFound from "pages/PageNotFound";
import ChatBot from "components/ChatBot";
import { Button, notification } from "antd";

import * as actions from "redux/Dashboard/actions.js";
import { CONSOLE_HOME_PATH, resolveAuthenticatedLandingPath } from "util/consoleHome";
import { buildSignupPath } from "authentication/Signup/signupProducts";
import AuthRouteGuard from "helperComponents/AuthRouteGuard";
import { isValidRouteId } from "util/routeIds";
import AppViewportShell from "helperComponents/AppViewportShell";
import ServiceUnavailable from "helperComponents/ServiceUnavailable";
import { hasUsableSessionToken, requestSessionToken } from "util/sessionToken";
import { rememberAccountReview } from "authentication/Login/accountReview";
// Public survey links, brand demo pages and Sonic Calendar booking pages render without a
// session and are never redirected into signup onboarding.
const isPublicSurveyPath = () =>
  typeof window !== "undefined" &&
  (window.location.pathname.startsWith("/s/") ||
    window.location.pathname.startsWith("/demos/") ||
    window.location.pathname.startsWith("/book/") ||
    window.location.pathname.startsWith("/appointment/"));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: !isPublicSurveyPath(),
      authenticated: isPublicSurveyPath() ? UNLOGGED : UNKNOWN,
      params: "",
      redirectURL: getParams(document.location.href).redirectURL,
      user: {},
      serviceUnavailable: false,
    };
  }

  getUserTheme() {
    if (localStorage.getItem("theme") === null) {
      apiRequest("users/theme", "POST", true)
        .then((res) => {
          if (res.success) {
            this.props.changeTheme(res.success);
          }
        })
        .catch((error) => console.log(error));
    } else {
      this.props.changeTheme(window.localStorage.getItem("theme"));
    }
  }
  navigate() {
    if (window.location.pathname == "/") {
      document.location.href = this.state.redirectURL
        ? this.state.redirectURL
        : document.location.origin + CONSOLE_HOME_PATH;
    }
  }

  UNSAFE_componentWillMount() {
    const analytics = firebase.analytics();

    firebase.auth().onAuthStateChanged(async (res) => {
      if (res) {
        firebase
          .database()
          .ref(`/users/${res.uid}`)
          .on("value", async (snapshot) => {
            let user = snapshot.val();
            if (user) {
              user.uid = snapshot.key;
              analytics.setUserId(user.uid);
              
              // Check if email is verified - if not, keep them in signup onboarding
              if (
                user &&
                !user.emailVerified &&
                window.location.pathname !== "/verification" &&
                window.location.pathname !== "/signup" &&
                !isPublicSurveyPath()
              ) {
                history.replace(
                  buildSignupPath(
                    user.intendedProduct,
                    persistAppLanguage(
                      user.language ||
                        window.localStorage.getItem("userLang") ||
                        i18n.language
                    )
                  )
                );
                this.setState({
                  loading: false,
                  authenticated: LOGGED,
                  user,
                });
                return;
              }
              
              // If email is verified but no plan, continue onboarding (product / pending).
              // Include /verification so a used verify link cannot leave a blank screen.
              if (
                user &&
                user.emailVerified &&
                user.plan === undefined &&
                window.location.pathname !== "/signup" &&
                !isPublicSurveyPath()
              ) {
                history.replace(
                  buildSignupPath(
                    user.intendedProduct,
                    persistAppLanguage(
                      user.language ||
                        window.localStorage.getItem("userLang") ||
                        i18n.language
                    )
                  )
                );
              }
              if (user.mandatoryLogout) {
                await firebase
                  .database()
                  .ref(`/users/${user.uid}/mandatoryLogout`)
                  .set(false);
                signout();
              }
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                userId: user.uid,
              });
              user.currency = "usd";
              user.currencySymbol = "$";

              const tokenResult = await requestSessionToken(user.uid, {
                getIdToken: () => firebase.auth().currentUser?.getIdToken(),
              });

              if (tokenResult.status === "review") {
                // Waiting for approval or rejected: no token. The login page says why.
                window.localStorage.removeItem("jwt_token");
                rememberAccountReview(tokenResult.code);
                signout(false);
                return;
              }

              if (tokenResult.status === "rejected") {
                // The API answered and refused to issue a token: end the session.
                // (A false result means apiRequest already handled expiry.)
                if (tokenResult.result) {
                  try {
                    apiRequest(
                      "users/client_log",
                      "POST",
                      { error: "Unable to generate new token - BE server" },
                      true
                    );
                  } catch (er) {
                    console.log(er);
                  }
                }
                window.localStorage.removeItem("jwt_token");
                sessionStorage.setItem("loginFailed", true);
                signout(false);
                return;
              }

              if (tokenResult.status === "unavailable") {
                // Temporary API outage: keep the session. Without a usable token
                // every request would 401 and sign the user out, so show the
                // unavailable page instead of the app until the API is back.
                if (!hasUsableSessionToken(user.uid)) {
                  this.setState({ loading: false, serviceUnavailable: true });
                  return;
                }
                notification.warning({
                  key: "service-unavailable",
                  message: i18n.t(
                    "service_unavailable.title",
                    "Service temporarily unavailable"
                  ),
                  description: i18n.t(
                    "service_unavailable.session_kept",
                    "Some data may not load until the service recovers. You're still signed in."
                  ),
                });
              } else {
                const remember_me_checked = window.localStorage.getItem(
                  "remember_me"
                );
                setWithExpiry(
                  "jwt_token",
                  tokenResult.accessToken,
                  remember_me_checked === "true" ? 1440 : 3
                );
                if (this.state.serviceUnavailable) {
                  // Recovered on a later users/ snapshot: load the app normally.
                  this.setState({ serviceUnavailable: false, loading: true });
                }
              }

              if (firebase.auth().currentUser) {
                firebase
                  .auth()
                  .currentUser.getIdToken(true)
                  .then((token) => {})
                  .catch((err) => {
                    signout(false);
                    try {
                      apiRequest(
                        "users/client_log",
                        "POST",
                        { error: "Unable to generate new token" },
                        true
                      );
                    } catch (er) {
                      console.log(er);
                    }
                    // window.location.href = window.location.origin + '/login';
                    sessionStorage.setItem("loginFailed", true);
                  });
              }

              initProductAnalytics(user.uid, history);

              $.ajax("https://get.geojs.io/v1/ip/country.json").then(
                (response) => {
                  user.country = response.name;
                  if (response.name === "Turkey") {
                    user.currency = "tl";
                    user.currencySymbol = "₺";
                  }
                  this.setState({
                    loading: false,
                    authenticated: LOGGED,
                    user,
                  });
                },

                (data, status) => {
                  this.setState({
                    loading: false,
                    authenticated: LOGGED,
                    user,
                  });
                }
              );
              this.getUserTheme();
              const subscription = await apiRequest(
                "subscriptions/all",
                "POST",
                {
                  user_id: user.uid,
                }
              );

              if (subscription?.[0]) {
                this.props.subscribe(subscription);
              }
              const applied = persistAppLanguage(
                resolveAuthenticatedAppLanguage({
                  search: window.location.search,
                  pathname: window.location.pathname,
                  accountLanguage:
                    subscription?.[0]?.language || user.language,
                  stored: window.localStorage.getItem("userLang"),
                  i18nLanguage: i18n.language,
                })
              );
              // A public survey page keeps the survey's language, not the signed-in viewer's.
              if (!window.location.pathname.startsWith("/s/")) {
                void i18n.changeLanguage(applied);
              }
              try {
                firebase.auth().languageCode = applied;
              } catch {
                // ignore
              }

              this.setState({
                loading: false,
                authenticated: LOGGED,
                user,
              });
              if (window.location.pathname == "/login") {
                const loginParams = getParams(document.location.href);
                const afterLogin = resolveAuthenticatedLandingPath(
                  loginParams,
                  user,
                  subscription?.[0]
                );
                history.push(afterLogin);
              }

              // this.navigate()
            } else {
              console.log("out");
            }
          });
      } else {
        if (res?.error) {
          try {
            apiRequest(
              "users/client_log",
              "POST",
              { error: res.error, message: "Login Failed" },
              true
            );
          } catch (er) {
            console.log(er);
          }

          console.log(res.error);
        }
        this.setState({ loading: false, authenticated: UNLOGGED });
        resetProductAnalytics();
      }
    });
  }

  render() {
    let { authenticated, user, loading, serviceUnavailable } = this.state;
    let { theme: rawTheme } = this.props;
    const theme = normalizeTheme(rawTheme);
    document.documentElement.style.setProperty(
      "--body",
      theme === "dark" ? DARK.bgBase : "#ffffff"
    );
    document.documentElement.style.setProperty(
      "--font",
      theme === "dark" ? "#ffffff" : theme === "light" ? "#000000" : BRAND_THEME.chrome
    );

    document.documentElement.style.setProperty(
      "--active",
      theme === "brand" ? BRAND_THEME.chrome : BRAND.primary
    );
    document.documentElement.style.setProperty(
      "--secondary",
      theme === "dark" ? DARK.bgSurface : theme === "light" ? "#E8E0F4" : "#f4f4f4"
    );

    /* Dark: elevated panels (cards, dropdowns) vs deeper canvas — website palette */
    const darkSurface = DARK.bgElevated;
    const darkSeparator = DARK.bgSubtle;
    document.documentElement.style.setProperty(
      "--line",
      theme === "dark" ? darkSeparator : "#00000024"
    );
    document.documentElement.style.setProperty(
      "--border",
      theme === "dark" ? darkSeparator : theme === "light" ? "#D4C8E8" : "#f4f4f4"
    );
    document.documentElement.style.setProperty(
      "--popup",
      theme === "dark" ? darkSurface : "#ffffff"
    );
    document.documentElement.style.setProperty(
      "--modal-surface",
      theme === "dark" ? DARK.modalSurface : "#ffffff"
    );
    document.documentElement.style.setProperty(
      "--overlay-scrim",
      theme === "dark" ? "rgba(5, 5, 15, 0.55)" : "rgba(0, 0, 0, 0.45)"
    );

    /* Legacy tokens (--color1/2/4/5) used by module SCSS; must track user theme preference */
    const surfaceHover =
      theme === "dark"
        ? "rgba(255, 255, 255, 0.04)"
        : "rgba(var(--color3-rgb), 0.06)";
    document.documentElement.style.setProperty("--surface-hover", surfaceHover);
    document.documentElement.style.setProperty(
      "--color1",
      theme === "dark" ? DARK.bgBase : "#ffffff"
    );
    document.documentElement.style.setProperty(
      "--color2",
      theme === "dark" ? darkSurface : "#ffffff"
    );
    document.documentElement.style.setProperty(
      "--color4",
      theme === "dark" ? DARK.textMuted : "#6b6f8a"
    );
    document.documentElement.style.setProperty(
      "--color5",
      theme === "dark" ? darkSeparator : theme === "light" ? "#E8E0F4" : "#f4f4f4"
    );
    document.documentElement.style.setProperty(
      "--color3-hover",
      theme === "brand" ? BRAND_THEME.chrome : BRAND.primaryHover
    );
    document.documentElement.style.setProperty(
      "--color3",
      theme === "brand" ? BRAND_THEME.chrome : BRAND.primary
    );
    document.documentElement.style.setProperty(
      "--color3-rgb",
      theme === "brand" ? BRAND_THEME.chromeRgb : BRAND.primaryRgb
    );
    document.documentElement.style.setProperty("--color6", BRAND.secondary);
    document.documentElement.style.setProperty("--color6-rgb", BRAND.secondaryRgb);
    document.documentElement.style.setProperty(
      "--color-brand-tertiary",
      BRAND.tertiary
    );
    document.documentElement.style.setProperty(
      "--gradient-brand",
      `linear-gradient(135deg, ${BRAND.primary}, ${BRAND.secondary} 50%, ${BRAND.tertiary})`
    );
    document.documentElement.setAttribute("data-theme", theme);

    if (theme === "dark") {
      document.documentElement.style.setProperty("--console-rail", DARK.bgSurface);
    } else {
      document.documentElement.style.removeProperty("--console-rail");
    }

    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      const getScrollBtn = document.querySelector("#scroll-to-top");
      if (!getScrollBtn) return;
      if (scrolled > 600) {
        getScrollBtn.style.bottom = "127px";
      } else if (scrolled <= 600) {
        getScrollBtn.style.bottom = "-48px";
      }
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    window.addEventListener("scroll", toggleVisible);

    if (serviceUnavailable && !isPublicSurveyPath()) return <ServiceUnavailable />;
    if (loading && !isPublicSurveyPath()) return <Loading />;

    return (
      <>
        <Router history={history}>
          <AuthRouteGuard authenticated={authenticated}>
          <AppViewportShell
            authenticated={authenticated}
            user={user}
            theme={theme}
          >
          <Switch>
            <Route
              exact
              path="/login"
              render={(props) => (
                <IndexLayout authenticated={LOGGED} user={user} theme={theme}>
                  <Login
                    authenticated={LOGGED}
                    user={user}
                    theme={theme}
                    {...props}
                  />
                </IndexLayout>
              )}
            />
            <Route
              path="/global_executive/presentation"
              render={() => (
                <KpiPresentationView authenticated={authenticated} user={user} />
              )}
            />
            <Route
              path="/global_executive/reviews"
              render={() => (
                <KpiPresentationView
                  authenticated={authenticated}
                  user={user}
                  reviewsMode
                />
              )}
            />
            {/* OAuth consent for MCP clients (Claude); signed-in only, the guard sends others to /login */}
            <Route exact path="/connect/consent" component={ConnectConsent} />
            <Route
              exact
              path="/reset-password"
              render={(props) => (
                <ResetPassword
                  authenticated={LOGGED}
                  user={user}
                  theme={theme}
                  {...props}
                />
              )}
            />
            {routes
              .filter((route) => route.public)
              .map((route) => (
                <Route
                  exact
                  path={route.path}
                  key={route.path}
                  render={(props) => (
                    <route.type {...props} theme={theme} />
                  )}
                />
              ))}
            {/* Console pages take a numeric id, share pages the share hash */}
            <Route
              exact
              path={[
                "/console/Dashboard/:id",
                "/console/DashboardData/:id",
                "/console/geolocation/:id",
                "/console/insights/:id",
                "/console/journey/:id",
                "/console/combined-view/:id",
                "/console/topic-gap/:id",
                "/share/Dashboard/:id",
                "/share/DashboardData/:id",
                "/share/insights/:id",
              ]}
              render={({ match }) => {
                const { id } = match.params;
                if (isValidRouteId(match.path, id)) {
                  const matchingRoute = routes.find(
                    (route) => route.path === match.path
                  );
                  if (matchingRoute) {
                    let DynamicComponent = matchingRoute.type;
                    return (
                      <IndexLayout
                        authenticated={authenticated}
                        user={user}
                        theme={theme}
                      >
                        <DynamicComponent
                          authenticated={authenticated}
                          user={user}
                          theme={theme}
                          match={match}
                          {...matchingRoute.props}
                        />
                      </IndexLayout>
                    );
                  }
                } else {
                  // Display PageNotFound if the id is not valid for this page
                  return (
                    <PageNotFound
                      authenticated={LOGGED}
                      user={user}
                      theme={theme}
                    />
                  );
                }
              }}
            />
            {/* Redirect legacy /home → Pivony Advisor */}
            <Route exact path="/home">
              <Redirect to={CONSOLE_HOME_PATH} />
            </Route>
            {/* Sonic Survey moved from /console/feedback-capture (old links and emails) */}
            <Route
              path="/console/feedback-capture"
              render={({ location }) => (
                <Redirect
                  to={{
                    pathname: location.pathname.replace(
                      "/console/feedback-capture",
                      "/console/sonic-survey"
                    ),
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              )}
            />
            {/* Redirect Topic Library into Settings */}
            <Route
              exact
              path="/console/followed"
              render={({ location }) => {
                const params = new URLSearchParams(location.search);
                params.set("tab", "followed");
                return (
                  <Redirect
                    to={{
                      pathname: "/settings/topic-library",
                      search: `?${params.toString()}`,
                    }}
                  />
                );
              }}
            />
            <Route
              exact
              path="/console/topicLibrary"
              render={({ location }) => (
                <Redirect
                  to={{
                    pathname: "/settings/topic-library",
                    search: location.search,
                  }}
                />
              )}
            />
            <Route
              exact
              path="/console/topicLibrary/custom_topics"
              render={({ location }) => {
                const params = new URLSearchParams(location.search);
                params.set("tab", "custom");
                return (
                  <Redirect
                    to={{
                      pathname: "/settings/topic-library",
                      search: `?${params.toString()}`,
                    }}
                  />
                );
              }}
            />
            <Route
              exact
              path="/console/topicLibrary/industry_topics"
              render={({ location }) => {
                const params = new URLSearchParams(location.search);
                params.set("tab", "industry");
                return (
                  <Redirect
                    to={{
                      pathname: "/settings/topic-library",
                      search: `?${params.toString()}`,
                    }}
                  />
                );
              }}
            />
            {/* Redirect legacy Custom Topics tab → Topics (combined-view) */}
            <Route
              exact
              path="/console/customTopics/:id"
              render={({ match, location }) => (
                <Redirect
                  to={{
                    pathname: `/console/combined-view/${match.params.id}`,
                    search: location.search,
                  }}
                />
              )}
            />
            <Route exact path="/console/ai-services/auto-refresh">
              <Redirect to="/console/ai-services/auto-reports-settings" />
            </Route>
            <Route exact path="/console/ai-services/reports">
              <Redirect to="/console/ai-services/auto-reports" />
            </Route>
            <Route
              exact
              path="/console/ai-services/reports/:reportId"
              render={({ match }) => (
                <Redirect to={`/console/ai-services/auto-reports/${match.params.reportId}`} />
              )}
            />
            {routes
              .filter((route) => !route.public)
              .map((route) => (
              <Route
                exact
                path={route.path}
                key={route.path}
                render={(props) => (
                  <IndexLayout
                    authenticated={authenticated}
                    user={user}
                    theme={theme}
                  >
                    <route.type
                      authenticated={authenticated}
                      user={user}
                      theme={theme}
                      {...props}
                      {...route.props}
                    />
                  </IndexLayout>
                )}
              />
            ))}
            {/* PageNotFound route */}
            <Route
              render={() => (
                <PageNotFound
                  authenticated={LOGGED}
                  user={user}
                  theme={theme}
                />
              )}
            />
          </Switch>
          </AppViewportShell>
          </AuthRouteGuard>
        </Router>
        {/* <ChatBot/> */}
        <div id="scroll-to-top" onClick={scrollToTop}>
          <i className="fa-solid fa-arrow-up"></i>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changeTheme: (color) => {
      return dispatch({
        type: actions.THEME_MODE,
        payload: {
          theme: normalizeTheme(color),
        },
      });
    },
    subscribe: (subscription) => {
      return dispatch({
        type: SET_USER,
        payload: subscription[0],
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    theme: state.DashboardReducer.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
